import { MbmProvider } from '@amzn/react-arb-tools';
import { brandTheme } from '@amzn/stencil-design-tokens/js/web/theme';
import {
  StencilProvider,
  ThemeMode,
} from '@amzn/stencil-react-components/context';
import { QueryClient } from '@tanstack/query-core';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import arbManifest from 'translations/arbManifest';
import { getMbmOptions } from '../helpers';
import GrowThriveConnectPage from './GrowThriveConnectPage';
import { useEffect, useState } from 'react';
import GrowThriveConnectLayout from './GrowThriveConnectLayout';
import { getAwsRumInstance } from 'src/analytics/rum';

const mbmOptions = getMbmOptions(arbManifest);

const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const AppContent = () => {
  const [isDark, setIsDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (event: any) => {
      setIsDark(event.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <StencilProvider
      theme={brandTheme}
      themeMode={isDark ? ThemeMode.Dark : ThemeMode.Light}
    >
      <GrowThriveConnectLayout>
        <Routes>
          <Route path="/" element={<GrowThriveConnectPage />} />
        </Routes>
      </GrowThriveConnectLayout>
    </StencilProvider>
  );
};

const App = () => {
  const [queryClient] = useState(() => new QueryClient());
  getAwsRumInstance();

  return (
    <MbmProvider {...mbmOptions}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={routerFutureFlags}>
          <AppContent />
        </BrowserRouter>
      </QueryClientProvider>
    </MbmProvider>
  );
};

export default App;
